import { FundAdditionType } from "../interfaces/DTO/simulation";
import { ProducerCommissionCompanyOverride } from "../interfaces/DTO/commissions/producerCommission";

/**
 * The saving fee the agent proposes at a handler for the client's total there - the first of the handler's
 * overrides (by sort_order) whose min/max range holds the total
 */
export const findProposedFees = (
  totalFundsSum: number,
  sortedOverrides: ProducerCommissionCompanyOverride[]
): number | null => {
  const relevant = sortedOverrides.find(
    (o) =>
      (o.min_value === null || o.min_value === undefined || totalFundsSum >= o.min_value) &&
      (o.max_value === null || o.max_value === undefined || totalFundsSum <= o.max_value)
  );
  return relevant?.saving_fee ?? null;
};

/**
 * Returns the color for a given fund addition type
 */
export const getAdditionTypeColor = (type: FundAdditionType): string => {
  switch (type) {
    case 'deposit': return '#b1d08a';
    case 'recurrent': return '#008000';
    case 'transfer': return '#9c27b0';
    case 'withdrawal': return '#ef8583';
  }
};

/**
 * Returns the Hebrew label for a given fund addition type
 */
export const getAdditionTypeLabel = (type: FundAdditionType): string => {
  switch (type) {
    case 'deposit': return 'הפקדה';
    case 'recurrent': return 'הוראת קבע';
    case 'transfer': return 'ניוד';
    case 'withdrawal': return 'משיכה';
  }
};
